import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const OrgDashboardAppLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "OrgDashboard" */
      './OrgDashboardApp.dynamic'
    ),
  loading: LoadingPageLoadable,
});
